export const SET_PRODUCT_LIST = 'SET_PRODUCT_LIST';
export const SET_PRODUCT_LIST_PAGE_NUM = 'SET_PRODUCT_LIST_PAGE_NUM';
export const SET_PRODUCT_LIST_PAGE_COUNT = 'SET_PRODUCT_LIST_PAGE_COUNT';

export const SET_PRODUCT_FILTER = 'SET_PRODUCT_FILTER';
export const RESET_PRODUCT_FILTER = 'RESET_PRODUCT_FILTER';

export const SET_PRIMARY_CATELIST = 'SET_PRIMARY_CATELIST';
export const SHOW_ADD_GOODS_MASK = 'SHOW_ADD_GOODS_MASK';
export const HIDE_ADD_GOODS_MASK = 'HIDE_ADD_GOODS_MASK';
export const SHOW_EDIT_MATERIAL_INFO_MASK = 'SHOW_EDIT_MATERIAL_INFO_MASK';
export const HIDE_EDIT_WEISHI_MASK = 'HIDE_EDIT_WEISHI_MASK';
export const SET_EDIT_ITEM = 'SET_EDIT_ITEM';
export const REMOVE_EDIT_ITEM = 'REMOVE_EDIT_ITEM';

export const SET_ACTIVE_TAB_INDEX = 'SET_ACTIVE_TAB_INDEX';
export const RESET = 'RESET';
export const CHANGE_LOADING = 'CHANGE_LOADING';
export const SET_MEDIA_INFO = 'SET_MEDIA_INFO';

export const STEP = {
  BOUTIQUE: 'BOUTIQUE', // 精品库
  COMMODITY_LINK: 'COMMODITY_LINK', // 添加商品链接
  ALL: 'ALL',
};

export const MESSAGE = {
  BOUTIQUE: '点击这里就可以进入精品库哦',
  COMMODITY_LINK: '点击这里添加京东/拼多多商品链接',
  ALL: '点击这里就可以看全部宝贝哦',
};
